import Vue from 'vue';
import Vuex from 'vuex';
import LocalOfficeInfo from './modules/local-office-info';
import LocationSearch from './modules/location-search';
import OnlineScheduling from './modules/online-scheduling';
import FormContactUs from './modules/form-contact-us';
import NextAvailable from './modules/next-available';
import FormRequestAppointment from './modules/form-request-appointment';
import ClientToken from './modules/client-token';
import GoogleApi from './modules/google-api';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
	modules: {
		LocalOfficeInfo,
		LocationSearch,
		OnlineScheduling,
		FormContactUs,
		NextAvailable,
		FormRequestAppointment,
		ClientToken,
		GoogleApi
	},
	strict: debug,
});
